import React from "react";

import { IViewProps, View } from "core/decorators/View";
import { nDef } from "core/util/TypeUtils";
import Link, { Breadcrumbs } from "./Link";
import PageLinkViewConfig from "./PageLinkViewConfig";

/**
 * @overview: Dynamic link to another page that accepts params / search query
 * @author: jesposito
 */

export interface ILinkViewProps extends IViewProps<PageLinkViewConfig> {
	attrs?: object;
	params?: object;
	preserveParams?: boolean;
	render?: (props: { active: boolean; path?: string; }) => React.ReactNode | any;
	breadcrumbs?: Breadcrumbs;
}

export type BreadcrumbList = ILinkViewProps[];

@View({id: "link", configClass: PageLinkViewConfig})
export default class PageLinkView extends React.PureComponent<ILinkViewProps> {

	public render() {
		const { attrs, breadcrumbs, className, config, params, preserveParams, render, style } = this.props;

		if(nDef(config) || nDef(config.page)) {
			return typeof render === 'function' && render({active: false}) || this.props.children;
		}

		return (
			<Link
				attrs={attrs}
				prefix={config.page.path}
				instance={config.page.instance}
				preserveParams={preserveParams}
				params={params}
				className={className}
				style={style}
				breadcrumbs={breadcrumbs}
			>
				{render || (() => this.props.children)}
			</Link>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/pageLink/PageLink.view.tsx